import { getRequest, postRequest, putRequest, deleteRequest } from './api-requests';
import apiConfig from '../../../api-config';

export const Patients = Object.freeze({
    listFilter: (data = {}) => {
        let getString = '';
        if (data.sortBy !== undefined) {
            getString += `?sort_by=${data.sortBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`;
        }
        return getRequest(`${apiConfig.base_url}/web/patient${getString}`);
    },
    single: id => getRequest(`${apiConfig.base_url}/web/patient/${id}`),
    add: details => postRequest(`${apiConfig.base_url}/web/patient/register`, details),
    edit: (id, details) => putRequest(`${apiConfig.base_url}/web/patient/${id}`, details),
    delete: id => deleteRequest(`${apiConfig.base_url}/web/patient/${id}`),
    resendPassword: (id, details) =>  postRequest(`${apiConfig.base_url}/web/patient/password/${id}`, details)
});



// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-patients.js